import { render, staticRenderFns } from "./ModalCustomDomainInstructions.vue?vue&type=template&id=3cfbd03d&scoped=true"
import script from "./ModalCustomDomainInstructions.vue?vue&type=script&lang=js"
export * from "./ModalCustomDomainInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbd03d",
  null
  
)

export default component.exports